module.exports = __webpack_public_path__ + "static/media/Template_18.884b4627.png";